import { env } from "./env";

export const isSubscriptionAndPaywallEnabled = (): boolean => true;

export const isDashboardMealRecommendationsEnabled = (): boolean => false;

/** Keep the unfinished deficit dashboard out of production. */
export const isWeeklyCalorieDeficitDashboardEnabled = (): boolean =>
  env.VITE_ENVIRONMENT === "development" || env.VITE_ENVIRONMENT === "staging";
